/** Unset and any value other than the string true keep rental underwriting off. */
export function rentalUnderwritingEnabled(): boolean {
  return process.env.REACT_APP_RENTAL_UNDERWRITING_ENABLED === 'true';
}
